module.exports = "/_next/static/images/margelita-e6ff3e55042ff16ab8eb47694a5efa3b.jpg";